(function () {
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  function applyBFToWrapper(wrapper) {
    // Avoid double-initializing the same price block
    if (wrapper.dataset.bfInit === '1') return;
    wrapper.dataset.bfInit = '1';

    var priceEl = wrapper.querySelector('[data-price]');
    var pillEl  = wrapper.querySelector('[data-bf-pill]');
    if (!priceEl || !pillEl) return;

    function updateBlackFridayDeal() {
      var raw = priceEl.textContent || '';
      var numeric = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(numeric)) {
        pillEl.style.display = 'none';
        pillEl.textContent = '';
        pillEl.classList.remove('bf-deal-pill--active');
        priceEl.style.textDecoration = 'none';
        priceEl.style.opacity = '1';
        return;
      }

      var cents   = Math.round(numeric * 100);
      var bfCents = cents;
      var hasDeal = false;

      // ✅ UPDATED THRESHOLDS
      // 40% at $550+ , 30% at $350+ , 20% at $125+
      if (cents >= 55000) {
        bfCents = Math.floor((cents * 60 + 50) / 100); // 40% OFF
        hasDeal = true;
      } else if (cents >= 35000) {
        bfCents = Math.floor((cents * 70 + 50) / 100); // 30% OFF
        hasDeal = true;
      } else if (cents >= 12500) {
        bfCents = Math.floor((cents * 80 + 50) / 100); // 20% OFF
        hasDeal = true;
      }

      if (!hasDeal) {
        pillEl.style.display = 'none';
        pillEl.textContent = '';
        pillEl.classList.remove('bf-deal-pill--active');
        priceEl.style.textDecoration = 'none';
        priceEl.style.opacity = '1';
        return;
      }

      // Show discount: strike original, show pill
      priceEl.style.textDecoration = 'line-through';
      priceEl.style.opacity = '0.7';

      pillEl.style.display = 'inline-flex';
      pillEl.textContent   = 'FLASH DEAL: ' + formatMoney(bfCents);

      // Retrigger animation every time price changes
      pillEl.classList.remove('bf-deal-pill--active');
      void pillEl.offsetWidth;
      pillEl.classList.add('bf-deal-pill--active');
    }

    // Initial run
    updateBlackFridayDeal();

    // Re-run whenever the price text changes (variant change, etc.)
    var observer = new MutationObserver(updateBlackFridayDeal);
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  function initBFInScope(scope) {
    var roots = (scope || document).querySelectorAll('.product__price-and-ratings');
    if (!roots.length) return;
    roots.forEach(applyBFToWrapper);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBFInScope(document);

    var globalObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches('.product__price-and-ratings')) {
            applyBFToWrapper(node);
            return;
          }

          var found = node.querySelectorAll
            ? node.querySelectorAll('.product__price-and-ratings')
            : [];
          if (found && found.length) {
            found.forEach(applyBFToWrapper);
          }
        });
      });
    });

    globalObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();